import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { ConfigService } from "src/app/services/config.service";
import { SelectItem } from "primeng/api";
import { EmailTemplate } from "../setup/models/email-template.model";
import { AuthenticationService } from "src/app/services/authentication.service";

export const USER_DEFINED = "user_defined";

@Injectable()
export class EmailTemplateService {
    constructor(
        private httpClient: HttpClient,
        private configService: ConfigService,
        private authService: AuthenticationService,
    ) {
        this.getTemplates().subscribe((items) => {
            this.setTemplateList(items);
        });
    }

    templateList: EmailTemplate[] = [];
    templatesLoaded = false;

    toSelectItems(items: EmailTemplate[]): SelectItem[] {
        return items
            .filter((i) => {
                return i.function === USER_DEFINED;
            })
            .map((template) => {
                return {
                    label: template.name,
                    value: template.id,
                };
            });
    }

    getTemplates() {
        return this.httpClient.get<EmailTemplate[]>(
            this.configService.apiBaseUrl.concat("EmailTemplate"),
        );
    }

    setTemplateList(templates: EmailTemplate[]) {
        this.templateList.length = 0;
        this.templateList.push(...templates);
        this.templatesLoaded = true;
    }

    createTemplate(templateDto: any) {
        return this.httpClient.post<EmailTemplate>(
            this.configService.apiBaseUrl.concat("EmailTemplate/Create"),
            templateDto,
        );
    }

    updateTemplate(templateDto: EmailTemplate, templateId: number) {
        return this.httpClient.post<EmailTemplate>(
            this.configService.apiBaseUrl.concat(
                "EmailTemplate/Update/",
                templateId.toString(),
            ),
            templateDto,
        );
    }

    deleteEmailTemplate(templateId: number) {
        return this.httpClient.delete<EmailTemplate>(
            this.configService.apiBaseUrl.concat(
                "EmailTemplate/Delete/",
                templateId.toString(),
            ),
        );
    }

    addEmailTemplateToList(template: EmailTemplate) {
        this.templateList.unshift(template);
    }

    removeEmailTemplateFromList(templateId: number) {
        const index = this.templateList.findIndex((cat) => {
            return cat.id === templateId;
        });
        if (index >= 0) {
            this.templateList.splice(index, 1);
        }
    }

    replaceEmailTemplateInList(templateId: number, template: EmailTemplate) {
        const index = this.templateList.findIndex((cat) => {
            return cat.id === templateId;
        });
        if (index >= 0) {
            this.templateList.splice(index, 1, template);
        }
    }
}
